module.exports = __webpack_public_path__ + "static/media/abbott-lsa.d44cea64.png";